"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getProxyTCCHostname: ()=>getProxyTCCHostname
});
const row_js_namespaceObject = require("../../aegis-api-config/row.js");
const ttp_js_namespaceObject = require("../../aegis-api-config/ttp.js");
function getProxyTCCHostname() {
    let { isTest, isTTP, isFallbackHostname } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    if (isTest) return row_js_namespaceObject.rowApiConfig["proxy-tcc-boe"];
    if (isTTP) return ttp_js_namespaceObject.ttpApiConfig["proxy-tcc"];
    if (isFallbackHostname && !isTTP) return row_js_namespaceObject.rowApiConfig["proxy-tcc-pd"];
    return row_js_namespaceObject.rowApiConfig["proxy-tcc"];
}
exports.getProxyTCCHostname = __webpack_exports__.getProxyTCCHostname;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getProxyTCCHostname"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
